import React, {Component} from 'react';
import styles from 'css/components/form.css';

/**
 * get attributes
 * @param {string} type
 * @param {object} param
 * @return {object}
 */
function getAttributes(type, param = {}) {
  const {
    id = null,
    onChange = null,
    placeholder = null,
    name = null,
    checked = null,
    value = '',
  } = param;

  const attributes = {
    className: styles[type],
    type: type,
    value: value || '',
  };

  if (id) {
    attributes.id = id;
  }

  if (name) {
    attributes.name = name;
  }

  if (placeholder) {
    attributes.placeholder = placeholder;
  }

  if (onChange) {
    attributes.onChange = onChange;
  }

  switch (type) {
  case 'radio':
    attributes.checked = (value == checked ? 'checked' : '');
    break;
  case 'checkbox':
    attributes.className = null;
    attributes.checked = (value ? 'checked' : '');
    break;
  }
  return attributes;
}

/**
 * Input[type="text"]
 */
export class InputText extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const attributes = getAttributes('text', this.props);

    return (
      <input {...attributes} />
    );
  }
}

/**
 * Input[type="checkbox"]
 */
export class InputCheckBox extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      id,
    } = this.props;

    const attributes = getAttributes('checkbox', this.props);

    return (
      <span className={styles.checkbox}>
        <input {...attributes} />
        <label htmlFor={id}>{this.props.children}</label>
      </span>
    );
  }
}

/**
 * Textarea
 */
export class Textarea extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const attributes = getAttributes('textarea', this.props);

    return (
      <textarea {...attributes} />
    );
  }
}

/**
 * Input[type="radio"]
 */
export class InputRadio extends Component {
  /**
   * render jsx
   * @return {jsx}
   */
  render() {
    const {
      id,
    } = this.props;

    const attributes = getAttributes('radio', this.props);

    return (
      <span>
        <input {...attributes} />
        <label htmlFor={id}>{this.props.children}</label>
      </span>
    );
  }
}



// WEBPACK FOOTER //
// ./src/js/components/form/index.js